import Nullstack from 'nullstack';
export default function IconBus({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-bus",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M4 17h-2v-11a1 1 0 0 1 1 -1h14a5 7 0 0 1 5 7v5h-2m-4 0h-8"
  }), "   ", Nullstack.element("polyline", {
    points: "16 5 17.5 12 22 12"
  }), "   ", Nullstack.element("line", {
    x1: "2",
    y1: "10",
    x2: "17",
    y2: "10"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "5",
    x2: "7",
    y2: "10"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "10"
  }), " ");
}